<template>
  <div
    :class="[
      'pThumb flex-col flex__center clickable margin-right-10',
      active ? 'active' : ''
    ]"
    @click="$emit('click')"
  >
    <div class="pBgThumb" :style="`background-image: url( ${url} )`"></div>
    <div class="pIndex flex-row font-size__small font-weight__bold">
      <span>
        {{ title }}
      </span>
    </div>
    <div :class="['markIsModified', isModify === true ? 'on' : 'off']"></div>
  </div>
</template>

<script>
  export default {
    name: "p-thumbnail",
    props: ["url", "title", "active", "isModify"]
  };
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/p-thumbnail.vue